module.exports = __webpack_public_path__ + "img/about-bg.ef194ed9.jpg";